import React, { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "./game.css";
import Swal from "sweetalert2";
import { updateScore, updateLives,fetchQuestions, fetchCurrentQuestion, alreadyPlayed,updategameover } from "../../scoreservice";
import { isMultiplaySession } from "../../utils/multiplaySession";

// Will be defined after isMobile is available
let groundImg;
let baseCactusImgs;
const cloudImg = "/img/cloud.png";
const coinImg = "/img/coin.png";

// Will be defined after isMobile is available
let runningImgs;
let jumpingImgs;
let fallingImgs;

function Game({ updateHeader }) {

  const navigate = useNavigate();
  const location = useLocation();
  const gameWidth = window.innerWidth;
  const gameHeight = window.innerHeight - 100;

  // Mobile detection and scaling
  const isMobile = window.innerWidth < 600;
  groundImg = isMobile ? "/img/mobground.png" : "/img/ground.png";
  baseCactusImgs = isMobile ? [
    { src: "/img/cactus.png", width: 80, height: 120 },
    { src: "/img/cactus1.png", width: 80, height: 120 },
    { src: "/img/cactus2.png", width: 80, height: 100 },
  ] : [
    { src: "/img/cactus.png", width: 80, height: 120 },
    { src: "/img/cactus1.png", width: 80, height: 120 },
    { src: "/img/cactus2.png", width: 80, height: 100 },
  ];
  
  // Define dino image arrays based on device
  runningImgs = isMobile ? 
    ["/img/dino_run1.png", "/img/dino_run2.png", "/img/dino_run3.png", "/img/dino_run4.png", "/img/dino_run5.png", "/img/dino_run6.png"] :
    ["/img/dino_run1.png", "/img/dino_run2.png", "/img/dino_run3.png", "/img/dino_run4.png", "/img/dino_run5.png", "/img/dino_run6.png"];
  jumpingImgs = isMobile ?
    ["/img/dino_jump1.png", "/img/dino_jump2.png", "/img/dino_jump3.png", "/img/dino_jump4.png", "/img/dino_jump5.png", "/img/dino_jump6.png"] :
    ["/img/dino_jump1.png", "/img/dino_jump2.png", "/img/dino_jump3.png", "/img/dino_jump4.png", "/img/dino_jump5.png", "/img/dino_jump6.png"];
  fallingImgs = isMobile ?
    ["/img/dino_fall1.png", "/img/dino_fall2.png", "/img/dino_fall3.png", "/img/dino_fall4.png", "/img/dino_fall5.png"] :
    ["/img/dino_fall1.png", "/img/dino_fall2.png", "/img/dino_fall3.png", "/img/dino_fall4.png", "/img/dino_fall5.png"];
  const dinoScale = isMobile ? 0.7 : 1;

  // Scaled dimensions for dino
  const dinoWidth = 80 * dinoScale,
    dinoHeight = 100 * dinoScale,
    groundHeight = isMobile ? 240 : 240; // Slightly lower ground on mobile

  // Adjusted physics for mobile
  const gravity = -0.7,
    jumpForce = isMobile ? 18 : 18,
    [moveSpeed, setMoveSpeed] = useState(isMobile ? 2.5 : 5);
  const [speedBoostCount, setSpeedBoostCount] = useState(0);

  // Game speeds
  const groundSpeed = isMobile ? 2.0 : 4,
    cactusSpeed = isMobile ? 2.0 : 4,
    cloudSpeed = isMobile ? 1.5 : 3,
    coinSpeed = isMobile ? 2.0 : 4;

  // Cactus scaling for mobile
  const cactusScale = isMobile ? 0.5 : 1;

  const [userData, setUserData] = useState(null);
  const [themeData, setThemeData] = useState(null);
  const [textcolor, setTextColor] = useState("#000");
  const [buttonColor, setButtonColor] = useState("#975e1e");
  const [fetchError, setFetchError] = useState(false);
  const [finalGameOver, setfinalGameOver] = useState(false);
  const [alreadyPlayedBlocked, setAlreadyPlayedBlocked] = useState(false);
  const [alreadyPlayedChecking, setAlreadyPlayedChecking] = useState(
    () => !isMultiplaySession(JSON.parse(sessionStorage.getItem("userData") || "{}"))
  );

  const [gameStarted, setGameStarted] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const [quizMode, setQuizMode] = useState(false);
  const [quiz, setQuiz] = useState(null);
  const [quizOptions, setQuizOptions] = useState([]);
  const [correctAnswer, setCorrectAnswer] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [ReportId, setReportId] = useState(0);

  const [time, setTime] = useState(0);
  const [score, setScore] = useState(0);
  const [questionscore, setPerQuestionScore] = useState(0);
  const [coinCount, setCoinCount] = useState(0);
  const [lives, setLives] = useState(3);
  const [totalCoinQuestion, setTotalCoinQuestion] = useState(2);

  const [selectedOptionState, setSelectedOptionState] = useState(null);
  const [correctOptionState, setCorrectOptionState] = useState(null);

  // Refs for game objects
  const dinoX = useRef(30);
  const dinoY = useRef(groundHeight);
  const velocityY = useRef(0);
  const moveLeft = useRef(false);
  const moveRight = useRef(false);
  const jumpCount = useRef(0);
  const isFalling = useRef(false);

  const cactusList = useRef([]);
  const clouds = useRef([]);
  const coins = useRef([]);
  const groundOffset = useRef(0);

  const dinoFrame = useRef(0);
  const [dinoSprite, setDinoSprite] = useState(runningImgs[0] || '');

  const containerRef = useRef(null);
  const quizCooldown = useRef(false);
  const submittingQuiz = useRef(false);
  const animationFrameId = useRef(null);
  const autosaveIntervalRef = useRef(null);
  const alreadyPlayedCheckDoneRef = useRef(false);
  const fallPlayed = useRef(false);
  const fallTimeoutRef = useRef(null);
  const pauseWorld = useRef(false);
  const storedUserData = JSON.parse(sessionStorage.getItem("userData")) || {};
  // console.log("storedUserData", storedUserData);

  const STORAGE_KEY = "gameState_v1"; // key for autosave

  // ---- Helpers ----
  const handleSuccess = (msg) => {
    return Swal.fire({
      icon: 'success',
      title: 'Success!',
      text: msg,
      confirmButtonText: 'OK',
      customClass: { popup: 'custom-success-popup' }
    }).then(result => {
      return result; // Ensure we return the result
    });
  };

  const handleError = (msg) => {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: msg,
      customClass: { popup: 'custom-success-popup' }
    });
  };

  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  const formatTime = (t) => {
    const m = Math.floor(t / 60);
    const s = t % 60;
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  };

  // Debounced save function to reduce sessionStorage operations
  const debouncedSave = useRef(null);
  const saveGameStateDebounced = useCallback(() => {
    if (debouncedSave.current) clearTimeout(debouncedSave.current);
    debouncedSave.current = setTimeout(() => {
      saveGameState();
    }, 500); // Save every 500ms max
  }, []);


  const saveGameState = useCallback(() => {
    // console.log("saveGameState",time,score,coinCount,lives,gameOver);
    try {
      // Only save if game is started or if there's meaningful state to preserve
      // Allow timer to save even if game hasn't started, but skip if everything is at defaults
      if (!gameStarted && time === 0 && score === 0 && coinCount === 0 && lives === 3) {
        //console.log("Skipping save - game not started with default values");
        return;
      }

      // Always save if timer is running (time > 0) even if game hasn't started
      if (!gameStarted && time > 0) {
        console.log("Saving timer progress before game start");
      }

      const state = {
        gameStarted,
        gameOver,
        time,
        score,
        coinCount,
        lives,
        currentQuestionIndex,
        savedAt: Date.now()
      };
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      //console.log("Game state saved:", sessionStorage.getItem(STORAGE_KEY));
    } catch (err) {
      console.error("Failed to save game state", err);
    }
  }, [gameStarted, gameOver, time, score, coinCount, lives, currentQuestionIndex]);

  const restoreGameState = useCallback(() => {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) {
        console.log("No saved game state found");
        return;
      }

      const savedState = JSON.parse(raw);
      console.log("Restoring game state:", savedState);

      // Only restore if the saved state is recent (within last hour)
      const oneHourAgo = Date.now() - (60 * 60 * 1000);
      if (savedState.savedAt && savedState.savedAt < oneHourAgo) {
        console.log("Saved state is too old, starting fresh");
        return;
      }

      // Restore state with validation
      if (typeof savedState.time === 'number') setTime(savedState.time);
      if (typeof savedState.score === 'number') setScore(savedState.score);
      if (typeof savedState.coinCount === 'number') setCoinCount(savedState.coinCount);
      if (typeof savedState.lives === 'number') setLives(savedState.lives);
      if (typeof savedState.currentQuestionIndex === 'number') {
        setCurrentQuestionIndex(savedState.currentQuestionIndex);
      }

      if (savedState.gameStarted) setGameStarted(true);
      // Only restore gameOver if lives are actually 0, not just because it was saved
      if (savedState.gameOver && savedState.lives === 0) {

        setGameOver(true);
        console.log("restoreGameState--", gameOver);


      }

    } catch (err) {
      console.error("Failed to restore game state", err);
      // Clear corrupted state
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }, []);

  // 3. Call saveGameState whenever relevant state changes
  useEffect(() => {
    saveGameState();

  }, [gameStarted, gameOver, time, score, coinCount, lives, currentQuestionIndex, saveGameState]);
  // 4. Call restoreGameState on component moun
  useEffect(() => {
    restoreGameState();
  }, [restoreGameState]);

  // ----------------- Preload Images -----------------
  useEffect(() => {
    const images = [...runningImgs, ...jumpingImgs, ...fallingImgs, cloudImg, coinImg, ...baseCactusImgs.map(c => c.src)];
    images.forEach(src => {
      const img = new Image();
      img.onerror = () => {
        console.error(`Failed to load image: ${src}`);
      };
      img.src = src;
    });
  }, []);

  // ----------------- Data Load & Restore -----------------
  useEffect(() => {
    updateHeader({ backButtonRedirect: "/intro" });
    if (!storedUserData) return navigate("/login");

    setUserData(storedUserData);
    const storedTheme = JSON.parse(sessionStorage.getItem("themeData"));
    let storedUserData1 = JSON.parse(sessionStorage.getItem("userData") || "{}");
    console.log("storedUserData1", storedUserData1);
    if (storedTheme) {
      setThemeData(storedTheme);
      setTextColor(storedTheme.landing_page_title_color || "#000");
      setButtonColor(storedTheme.button_color || "#975e1e");
      setTotalCoinQuestion(storedTheme.coin_collect_show_questions || 2);
      setPerQuestionScore(storedTheme.points || 0);
      setLives(storedUserData1.lives || 3);
      //setScore(storedUserData1.total_score || 0);
      setScore(Number(storedUserData1.total_score) || 0);
      // setTime(storedUserData1.time || 0);
      setTime(formatTimeToSeconds(storedUserData1.time));
      setReportId(storedUserData1.reportId);

      console.log("lives----------",storedUserData1.lives);
    }

    // Restore saved game state (auto-resume silently)
    restoreGameState();

    // start autosave interval
    if (autosaveIntervalRef.current) clearInterval(autosaveIntervalRef.current);
    autosaveIntervalRef.current = setInterval(() => {
      saveGameState();
    }, 2000); // every 5 seconds

    return () => {
      if (autosaveIntervalRef.current) clearInterval(autosaveIntervalRef.current);
    };
  }, [navigate]); // run once on mount

  const formatTimeToSeconds = (timeStr) => {
  if (!timeStr) return 0;
  const [m, s] = timeStr.split(':').map(Number);
  return m * 60 + s;
};

  // ----------------- Fetch Questions when theme and session exist -----------------
 useEffect(() => {
    // console.log("Questions length:", questions.length);
    // console.log("Questions data:", questions);
    console.log("Gameover:", gameOver);
    if(gameOver){
    const reportData = {
        userId: storedUserData.userid || storedUserData.userId,
        sessionId: storedUserData.sessionId,
        organizationId: storedUserData.organizationId,
        gameOver: true
      };
      console.log("reportData GameOver", reportData);

      updategameover(reportData)
        .then(res => {
          const data = typeof res === "string" ? JSON.parse(res) : res;
          if (data.status === "success") {
            console.log("reportData GaveOver", data.data);


          } else {
            handleError(data.message);
            setFetchError(true);
          }
        })
        .catch(err => { console.error(err); setFetchError(true); });
      }

  }, [gameOver]);

  useEffect(() => {
    if (!storedUserData?.sessionId) return;

    const storedTheme = JSON.parse(sessionStorage.getItem("themeData"));
    if (!storedTheme?.themeName) return;

    console.log("storedUserData", storedUserData);
    console.log("storedTheme", storedTheme);

    const reportData = {
      userId: storedUserData.userid || storedUserData.userId,
      sessionId: storedUserData.sessionId,
      organizationId: storedUserData.organizationId,
      themeName: storedTheme.themeName
    };

    console.log("reportData", reportData);
    console.log("isMultiplaySession", isMultiplaySession(storedUserData));
    // alert(isMultiplaySession(storedUserData));

    if (isMultiplaySession(storedUserData)) {
      setAlreadyPlayedChecking(false);
    } else if (!alreadyPlayedCheckDoneRef.current) {
      alreadyPlayedCheckDoneRef.current = true;
      setAlreadyPlayedChecking(true);

      alreadyPlayed(reportData)
        .then(res => {
          if (!res) {
            return;
          }

          const data = typeof res === "string" ? JSON.parse(res) : res;
          console.log("alreadyPlayed data", data);

          if (data?.status === "success" && data?.message === "Already Played") {
            setAlreadyPlayedBlocked(true);
            setfinalGameOver(true);
            try {
              sessionStorage.removeItem(STORAGE_KEY);
            } catch (e) { /* ignore */ }

            handleSuccess("You have already played").then(result => {
              if (result.isConfirmed) {
                navigate("/leaderboard");
              }
            });
          }
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          setAlreadyPlayedChecking(false);
        });
    }

    fetchQuestions(reportData)
      .then(res => {
        const data = typeof res === "string" ? JSON.parse(res) : res;
        if (data.status === "success") {
          console.log("all Questions", data.data);
          setQuestions(data.data);
        } else {
          handleError(data.message);
          setFetchError(true);
        }
      })
      .catch(err => { console.error(err); setFetchError(true); });

    fetchCurrentQuestion(reportData)
      .then(res => {
        const data = typeof res === "string" ? JSON.parse(res) : res;

        if (data.status === "success" && data.data && data.data[0]) {
          console.log("Current Questions", data.data[0].currentQues);
          console.log("Current Questions", data.data[0]);
          setCurrentQuestionIndex(data.data[0].currentQues);
          // setTime(data.data[0].time);
          // setScore(data.data[0].total_score);
          // also persist immediately so restore stays consistent
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
            ...(JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {}),
            currentQuestionIndex: data.data[0].currentQues
          }));
        }
      })
      .catch(err => console.error(err));
  }, [themeData]); // run once on mount

  // ----------------- Speed Boost Every Minute -----------------
  useEffect(() => {
    if (!gameStarted || gameOver || quizMode) return;

    const speedInterval = setInterval(() => {
      setMoveSpeed(prevSpeed => {
        const newSpeed = prevSpeed + 0.5; // Increase speed by 0.5 every minute
        setSpeedBoostCount(prev => prev + 1);
        console.log(`Speed boosted! New speed: ${newSpeed} (Boost #${speedBoostCount + 1})`);
        return newSpeed;
      });
    }, 60000); // Every 60 seconds (1 minute)

    return () => clearInterval(speedInterval);
  }, [gameStarted, gameOver, quizMode, speedBoostCount]);

  // ----------------- Timer -----------------
  useEffect(() => {
    if (gameOver || quizMode || !gameStarted) return;
    const timer = setInterval(() => {
      setTime(t => {
        const newTime = t + 1;

        // Check for demo bypass and end game after 10 seconds
        if (storedUserData?.organizationId === "demobypass" && storedUserData?.sessionId === "demobypass" && newTime === 10) {
          setGameOver(true);
          const payload = {
            userId: storedUserData.userId || storedUserData.userid,
            sessionId: storedUserData.sessionId,
            organizationId: storedUserData.organizationId,
            currentQues: currentQuestionIndex + 1,
            points: score,
            time: formatTime(time)
          };

          updateScore(payload)
            .then(() => {
              Swal.fire({
                icon: 'info',

                text: 'Thank you for playing. Subscribe to any PLAN to play with your peers.',
                confirmButtonText: 'OK',
                customClass: { popup: 'custom-success-popup' }
              }).then(result => {
                if (result.isConfirmed) {
                  window.location.href = process.env.REACT_APP_BASE_URL + "/plans";
                }
              });

            })
            .catch(err => console.error(err));


        }

        try {
          const prev = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
          prev.time = newTime;

          sessionStorage.setItem(STORAGE_KEY, JSON.stringify(prev));
        } catch (e) { /* ignore */ }
        return newTime;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [gameOver, quizMode, gameStarted]);

  // ----------------- Keyboard -----------------
  useEffect(() => {
    const keyDown = e => {
      if (e.repeat) return;
      if (e.key === "ArrowLeft") moveLeft.current = true;
      if (e.key === "ArrowRight") moveRight.current = true;
      if (e.key === " " || e.key === "ArrowUp") jump();
    };
    const keyUp = e => {
      if (e.key === "ArrowLeft") moveLeft.current = false;
      if (e.key === "ArrowRight") moveRight.current = false;
    };
    window.addEventListener("keydown", keyDown);
    window.addEventListener("keyup", keyUp);
    return () => {
      window.removeEventListener("keydown", keyDown);
      window.removeEventListener("keyup", keyUp);
    };
  }, []);

  // ----------------- Tap/Click -----------------
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const handleTap = (e) => { if (e.target.tagName !== "BUTTON") jump(); };
    el.addEventListener("click", handleTap);
    el.addEventListener("touchstart", handleTap);
    return () => {
      el.removeEventListener("click", handleTap);
      el.removeEventListener("touchstart", handleTap);
    };
  }, []);

  // ----------------- Jump -----------------
  const jump = () => {
    if (quizMode || isFalling.current || jumpCount.current >= 1) return;
    velocityY.current = jumpForce;
    jumpCount.current++;
  };

  // helper to create a scaled cactus object
  const makeCactus = (base) => ({
    src: base.src,
    width: Math.round(base.width * cactusScale),
    height: Math.round(base.height * cactusScale),
    x: gameWidth + 50
  });

  // Initialize clouds with random positions and sizes in upper part of screen
  const initializeClouds = (count = isMobile ? 2 : 4) => {
    return Array.from({ length: count }, (_, i) => ({
      x: Math.random() * gameWidth * 1.5,
      y: 50 + Math.random() * 150, // Positioned in upper part of screen, above dino and cactus
      scale: isMobile ? 0.3 + Math.random() * 0.4 : 0.4 + Math.random() * 0.6, // Smaller clouds on mobile
      speed: isMobile ? 0.5 + Math.random() * 0.5 : 0.3 + Math.random() * 0.7 // Faster clouds on mobile
    }));
  };

  // ----------------- Game Loop -----------------
  useEffect(() => {
    if (!gameStarted || gameOver || quizMode) return;

    cactusList.current = [makeCactus(baseCactusImgs[Math.floor(Math.random() * baseCactusImgs.length)])];
    clouds.current = initializeClouds(isMobile ? 2 : 4); // Fewer clouds on mobile for better performance

    let frameCounter = 0;
    const runningFrameCount = runningImgs.length;
    const jumpingFrameCount = jumpingImgs.length;
    const fallingFrameCount = fallingImgs.length;

    const loop = () => {
      if (gameOver || quizMode) return;

      frameCounter++;
      // Animate Dino every 5 frames
      if (frameCounter % 5 === 0) {
        dinoFrame.current = (dinoFrame.current + 1);
        if (isFalling.current) {
          if (!fallPlayed.current) {
            const frameIndex = Math.min(dinoFrame.current, fallingFrameCount - 1);
            setDinoSprite(fallingImgs[frameIndex]);

            if (frameIndex === fallingFrameCount - 1) {
              fallPlayed.current = true; // stop looping
            }
          } else {
            // hold last fall frame
            setDinoSprite(fallingImgs[fallingFrameCount - 1]);
          }
        } else if (velocityY.current !== 0) {
          const jumpIndex = dinoFrame.current % jumpingFrameCount;
          setDinoSprite(jumpingImgs[jumpIndex]);
        } else {
          const runIndex = dinoFrame.current % runningFrameCount;
          if (runningImgs[runIndex]) {
            setDinoSprite(runningImgs[runIndex]);
          }
        }
      }

      // Ground
      // groundOffset.current = (groundOffset.current - groundSpeed) % 100;

      if (!pauseWorld.current) {
        // Ground
        groundOffset.current = (groundOffset.current - groundSpeed) % 100;

        // Cactus movement
        // cactusList.current = cactusList.current.map(c => ({
        //   ...c,
        //   x: c.x - cactusSpeed
        // }));

        // Clouds movement with variable speed and respawning
        clouds.current = clouds.current.map(cloud => {
          let newX = cloud.x - (cloud.speed * cloudSpeed);
          // If cloud moves off screen to the left, reset it to the right with new random properties
          if (newX < -100) {
            return {
              ...cloud,
              x: gameWidth + Math.random() * 200, // More spread out respawn
              y: 20 + Math.random() * 60, // Keep at top of screen
              scale: 0.4 + Math.random() * 0.6,
              speed: 0.3 + Math.random() * 0.7
            };
          }
          return { ...cloud, x: newX };
        });

        // Coins movement
        // coins.current = coins.current
        //   .map(c => ({ ...c, x: c.x - coinSpeed }))
        //   .filter(c => c.x > -30);
      }

      // Move Dino
      if (moveLeft.current) dinoX.current = Math.max(0, dinoX.current - moveSpeed);
      if (moveRight.current) dinoX.current = Math.min(gameWidth - dinoWidth, dinoX.current + moveSpeed);

      // Dino Y & Gravity
      dinoY.current += velocityY.current;
      velocityY.current += gravity;
      if (dinoY.current <= groundHeight) {
        dinoY.current = groundHeight;
        velocityY.current = 0;
        jumpCount.current = 0;
      }
      // Move Cactus (always move, even during collision)
      // Keep cactus speed consistent during jumps for fair gameplay
      const currentCactusSpeed = cactusSpeed;
      
      // On mobile, give extra speed boost to cacti when dino is jumping to help clear them
      let adjustedCactusSpeed = currentCactusSpeed;
      if (isMobile && velocityY.current !== 0) {
        // When dino is in the air on mobile, move cacti faster to help clear them
        adjustedCactusSpeed = currentCactusSpeed * 1.5; // 50% faster when jumping
      }
      
      cactusList.current = cactusList.current.map(c => ({ ...c, x: c.x - adjustedCactusSpeed }));
      if (!pauseWorld.current && cactusList.current[0]?.x < -cactusList.current[0].width) {
        cactusList.current.shift();
        const gap = 100 + Math.random() * 100;
        cactusList.current.push(makeCactus(baseCactusImgs[Math.floor(Math.random() * baseCactusImgs.length)]));
      }

      // Collision Detection with lives logic
      cactusList.current.forEach(c => {
        // Only check collision when dino is on or near the ground (not high in the air)
        const dinoBottom = dinoY.current;
        // Reduce dino collision box for more forgiving gameplay
        const adjustedDinoWidth = isMobile ? dinoWidth * 0.8 : dinoWidth * 0.9;
        const adjustedDinoHeight = isMobile ? dinoHeight * 0.8 : dinoHeight * 0.9;
        const dinoTop = dinoY.current + adjustedDinoHeight;
        const cactusTop = c.height + groundHeight;

        // Check collision when dino is on ground or falling, but not during upward jump
        // Also ensure dino is not high enough to clear cactus
        const dinoHeightAboveGround = dinoBottom - groundHeight;
        const minJumpHeightToClearCactus = isMobile ? 60 : 70; // Increased threshold for mobile
        const isHighEnoughToClear = dinoHeightAboveGround >= minJumpHeightToClearCactus;
        
        // Only check collision if dino is on ground OR falling AND not high enough to clear
        // Also add a small buffer zone to prevent immediate collision when starting to fall
        const isFallingDown = velocityY.current < -2; // Only consider falling when velocity is significantly negative
        const isInCollisionHeight = dinoBottom < cactusTop && 
                                  dinoTop > groundHeight && 
                                  (isFallingDown ? isHighEnoughToClear === false : dinoBottom <= groundHeight + 5);

        // Reduce cactus collision box for more forgiving gameplay
        const cactusCollisionWidth = c.width * 0.7; // Reduce cactus hit width by 30%
        const cactusCollisionHeight = c.height * 0.8; // Reduce cactus hit height by 20%
        const cactusCollisionX = c.x + (c.width - cactusCollisionWidth) / 2; // Center the reduced collision box

        const hit = dinoX.current + adjustedDinoWidth > cactusCollisionX &&
          dinoX.current < cactusCollisionX + cactusCollisionWidth &&
          isInCollisionHeight;

        if (hit && !isFalling.current && !gameOver) {
          isFalling.current = true;
          pauseWorld.current = true; // STOP WORLD
          fallPlayed.current = false;
          dinoFrame.current = 0;
          velocityY.current = -8;

          setLives(prevLives => {
            const newLives = prevLives - 1;

            // persist lives
            try {
              const prevState = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
              prevState.lives = newLives;
              console.log("lives", newLives);
              sessionStorage.setItem(STORAGE_KEY, JSON.stringify(prevState));
            } catch { }

            // Update lives in database
            const storedUserData = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
            const payload1 = {
              userId: storedUserData.userId || storedUserData.userid,
              sessionId: storedUserData.sessionId,
              organizationId: storedUserData.organizationId,
              lives: newLives,
            };
            console.log("Payload1 for lives", payload1);

            updateLives(payload1)
              .then(() => {
                console.log("Lives updated in database successfully");
              })
              .catch(err => console.error("Error updating lives:", err));

            // hold fallen pose
            fallTimeoutRef.current = setTimeout(() => {
              if (newLives <= 0) {
                // Capture current values immediately before setting game over
                const currentScore = score;
                const currentTime = time;
                
                setGameOver(true);
              
              } else {
                isFalling.current = false;
                pauseWorld.current = false; // RESUME WORLD
                fallPlayed.current = false;
                dinoFrame.current = 0;
                velocityY.current = 0;
                dinoY.current = groundHeight;
                if (runningImgs[0]) {
                  setDinoSprite(runningImgs[0]);
                }
              }
            }, 1200); // 2.5 seconds fall hold

            return newLives;
          });
        }
      });

      // Coins movement
      coins.current = coins.current.map(c => ({ ...c, x: c.x - coinSpeed })).filter(c => c.x > -30);
      if (!pauseWorld.current && Math.random() < 0.005 && !quizCooldown.current) {
        const spawnX = gameWidth + 50;
        const spawnY = groundHeight + 150 + Math.random() * 100;
        
        // Check minimum distance from existing coins
        const minDistance = 150; // Minimum pixels between coins
        const tooClose = coins.current.some(coin => 
          Math.abs(coin.x - spawnX) < minDistance && Math.abs(coin.y - spawnY) < 50
        );
        
        if (!tooClose) {
          coins.current.push({ x: spawnX, y: spawnY });
        }
      }

      coins.current.forEach((coin, idx) => {
        // Adjust collision detection for mobile dino size
        const adjustedDinoWidth = isMobile ? dinoWidth * 1.4 : dinoWidth;
        const adjustedDinoHeight = isMobile ? dinoHeight * 1.4 : dinoHeight;
        
        if (dinoX.current + adjustedDinoWidth > coin.x && dinoX.current < coin.x + 30 &&
          dinoY.current + adjustedDinoHeight > coin.y && dinoY.current < coin.y + 30) {
          coins.current.splice(idx, 1);

          // Add 1 score per coin
          setScore(prev => {
            const newScore = Number(prev) + 1;
            try {
              const prevState = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
              prevState.score = newScore;
              console.log("newScore", newScore);
              sessionStorage.setItem(STORAGE_KEY, JSON.stringify(prevState));
            } catch (e) { /* ignore */ }
            return newScore;
          });
          setCoinCount(prevCount => {
            const updatedCount = Number(prevCount) + 1;
            try {
              const prevState = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
              prevState.coinCount = updatedCount;
              console.log("CoinCount", updatedCount);
              sessionStorage.setItem(STORAGE_KEY, JSON.stringify(prevState));
            } catch (e) { /* ignore */ }

            console.log("totalCoinQuestion------", totalCoinQuestion);

            // Trigger quiz after collecting 2 coins
            if (updatedCount >= totalCoinQuestion) {
              // Check if questions are completed before triggering quiz
              if (currentQuestionIndex > (questions.length - 1)) {
                // Questions are over, end game immediately
                cancelAnimationFrame(animationFrameId.current);
                setGameOver(true);
                console.log("Game Over - All questions completed!");
                return updatedCount;
              }
              
              // --- Stop horizontal movement but allow natural landing ---
              moveLeft.current = false;
              moveRight.current = false;
              isFalling.current = false;

              // --- Function to check if dino has landed and trigger quiz ---
              const checkLandingAndTriggerQuiz = () => {
                if (dinoY.current <= groundHeight && velocityY.current === 0) {
                  // Dino has landed naturally
                  cancelAnimationFrame(animationFrameId.current); // stop running loop briefly
                  if (runningImgs[0]) {
                    setDinoSprite(runningImgs[0]); // show standing frame
                  }
                  
                  // --- Small pause before quiz appears ---
                  setTimeout(() => {
                    triggerQuiz();
                  }, 500); // shorter delay since landing is already smooth
                } else {
                  // Still in air, check again in next frame
                  requestAnimationFrame(checkLandingAndTriggerQuiz);
                }
              };

              // --- Start checking for landing ---
              setTimeout(() => {
                checkLandingAndTriggerQuiz();
              }, 100); // brief delay to let current frame complete
            }

            return updatedCount;
          });

        }
      });

      animationFrameId.current = requestAnimationFrame(loop);
    };

    animationFrameId.current = requestAnimationFrame(loop);

    return () => { if (animationFrameId.current) cancelAnimationFrame(animationFrameId.current); };
  }, [gameStarted, gameOver, quizMode, questions]); // re-run when these flags change

  // ----------------- Quiz -----------------
  const triggerQuiz = () => {
    // If there are no more questions -> end game
    console.log("currentQuestionIndex", currentQuestionIndex);
    console.log("questions.length", questions.length);
    if (currentQuestionIndex > (questions.length-1)) {
      setQuizMode(false);
      setGameOver(true);
      console.log("Questionsover--", gameOver);
      return;
    }
    if (quizCooldown.current || currentQuestionIndex > (questions.length-1)) return;
    quizCooldown.current = true;
    setTimeout(() => { quizCooldown.current = false }, 1000);

    const currentQ = questions[currentQuestionIndex];
    if (!currentQ) return;

    const optionsArray = [];
    const totalOptions = parseInt(currentQ.showOption, 10);
    for (let i = 1; i <= totalOptions; i++) {
      const opt = currentQ[`option_${["one", "two", "three", "four", "five", "six"][i - 1]}`];
      if (opt) optionsArray.push(opt);
    }
    setCorrectAnswer(currentQ.correct_answer);
    setQuiz(currentQ);
    setQuizOptions(optionsArray);
    setQuizMode(true);
  };

  const handleQuizAnswer = (selectedOption) => {

    if (!quiz || submittingQuiz.current) return;
    submittingQuiz.current = true;

    // Highlight UI
    setSelectedOptionState(selectedOption);
    setCorrectOptionState(correctAnswer);


    const points = selectedOption === correctAnswer ? Number(questionscore) : 0;

    // Increase dino speed for correct answer
    if (selectedOption === correctAnswer) {
      setMoveSpeed(prevSpeed => {
        const speedBoost = isMobile ? 1.0 : 1.5; // Increased boost: double for mobile, 50% more for desktop
        const newSpeed = prevSpeed + speedBoost;
        console.log(`Speed increased! New speed: ${newSpeed}`);
        return newSpeed;
      });                                   
    }

    if (storedUserData?.organizationId === "demobypass" && storedUserData?.sessionId === "demobypass") {
      setGameOver(true);
      const payload = {
        userId: storedUserData.userId || storedUserData.userid,
        sessionId: storedUserData.sessionId,
        organizationId: storedUserData.organizationId,
        currentQues: currentQuestionIndex + 1,
        points: score + points,
        time: formatTime(time)
      };

      updateScore(payload)
        .then(() => {
          Swal.fire({
            icon: 'info',
            text: 'Thank you for playing. Subscribe to any PLAN to play with your peers.',
            confirmButtonText: 'OK',
            customClass: { popup: 'custom-success-popup' },
          }).then(result => {
            if (result.isConfirmed) {
              window.location.href = process.env.REACT_APP_BASE_URL + "/plans";
            }
          });

        })
        .catch(err => console.error(err));


    } else {


      addreport(points);
    }
  };

  function addreport(points, currentScore = null, currentTime = null) {
    // Check if this is the last question to handle game over after update
    const isLastQuestion = currentQuestionIndex >= (questions.length - 1);
    
    // Only increment if there are more questions
    const nextQuestionIndex = Number(currentQuestionIndex) + 1;
    setCurrentQuestionIndex(nextQuestionIndex);
    console.log("currentQuestionIndex----------", nextQuestionIndex);
    
    // Use provided values for game over case, otherwise use state
    const finalScore = currentScore !== null ? currentScore : score;
    const finalTime = currentTime !== null ? currentTime : time;
    
    setScore(prev => {
      const newScore = Number(prev) + points;
      try {
        const prevState = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
        prevState.score = newScore;
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(prevState));
      } catch { }
      return newScore;
    });

    setCoinCount(prev => {
      const newCount = Number(prev) + points; // if you want coinCount to track points too
      try {
        const prevState = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
        prevState.coinCount = newCount;
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(prevState));
      } catch { }
      return newCount;
    });

    const payload = {
      userId: storedUserData.userId || storedUserData.userid,
      sessionId: storedUserData.sessionId,
      organizationId: storedUserData.organizationId,
      currentQues: Number(currentQuestionIndex) + 1,
      points: finalScore + points,
      time: formatTime(finalTime)
    };

    // Return the Promise from updateScore
    return updateScore(payload)
      .then(() => {
        //const isGuest = storedUserData.roles === "GUEST_USER";
        const role1 =
        storedUserData?.roles ||
        storedUserData?.user_type ||
        storedUserData?.role;

      const isGuest = role1 === "GUEST_USER";

        let reportUrl;
        let reportRequestData;

        if (isGuest) {
          reportUrl = process.env.REACT_APP_UPDATE_GUEST_REPORT_URL;
          reportRequestData = {
            reportId: ReportId,
            points: Number(finalScore) + Number(points),
            time: "00:" + formatTime(finalTime)
          };
        } else {
          reportUrl = `${process.env.REACT_APP_UPDATE_REPORT_URL}/${ReportId}`;
          reportRequestData = {
            points: Number(finalScore) + Number(points),
            time: "00:" + formatTime(finalTime),
            reportId: ReportId,
            // reportId intentionally left out of body for org (kept in URL)
          };
        }
        console.log(reportRequestData);
        const headers = {
          'client-secret': process.env.REACT_APP_CLIENT_SECRET,
          'Content-Type': 'application/json'
        };

        if (!isGuest) {
          headers["Authorization"] = `Bearer ${storedUserData.token}`;
        }

        headers["Idempotency-Key"] = uuidv4();
        return axios.put(reportUrl, reportRequestData, { headers });
      })
      .then(() => {
        // Check if this was the last question and end game after successful report update
        if (isLastQuestion) {
          setQuizMode(false);
          setGameOver(true);
          console.log("Game Over - All questions completed and score updated!");
          return;
        }
      })
      .catch(() => handleError("Something went wrong! Please try again."))
      .finally(() => {
        // save state immediately after completing quiz answer flow
        saveGameState();

        // Reset coinCount to 0 so next quiz requires new 2 coins
        setCoinCount(0);
        try {
          const prevState = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
          prevState.coinCount = 0;
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify(prevState));
        } catch (e) {
          /* ignore */
        }
        
        setTimeout(() => {
          setQuizMode(false);
          setQuiz(null);
          setSelectedOptionState(null);
          setCorrectOptionState(null);
          submittingQuiz.current = false;

          // RESUME GAME WORLD
          pauseWorld.current = false;
          isFalling.current = false;
          fallPlayed.current = false;
          dinoFrame.current = 1; // Start with frame 1 to ensure running animation
          velocityY.current = 0;
          dinoY.current = groundHeight;
          if (runningImgs[1]) {
            setDinoSprite(runningImgs[1]); // Set to second running frame
          }
        }, 1200); // 1.2s highlight time
      });
  }

  useEffect(() => {
    if (gameOver) {
      console.log("Game Over - Final Score:", score, "Time:", formatTime(time));
      
      // Call addreport with final score and time when game ends
      // Only call if finalGameOver is false (don't call if already played)
      // Also don't call if game ended due to completing all questions (to avoid duplicate)
      if(!finalGameOver && currentQuestionIndex <= (questions.length - 1)){
          addreport(0, score, time)
            .then(() => {
              console.log("Final report submitted successfully");
            })
            .catch((error) => {
              console.error("Failed to submit final report:", error);
              handleError("Failed to save your final score. Please try again.");
            })
            .finally(() => {
              // Clean up sessionStorage after report is handled
              setTimeout(() => {
                try {
                  sessionStorage.removeItem(STORAGE_KEY);
                  console.log("Game state cleared from sessionStorage");
                } catch (e) { 
                  console.error("Failed to clear sessionStorage:", e); 
                }
              }, 1000); // Shorter delay to ensure report is processed
            });
      }
    }
  }, [gameOver, score, time, finalGameOver, addreport]);

  useEffect(() => {
    if (gameOver && !alreadyPlayedBlocked) {
      const redirectTimer = setTimeout(() => {
        navigate("/leaderboard");
      }, 5000);

      return () => clearTimeout(redirectTimer);
    }
  }, [gameOver, alreadyPlayedBlocked, navigate]);

  const handleOk = () => navigate("/leaderboard");

  // ----------------- Render -----------------
  return (
    <div ref={containerRef} style={{ width: "100%", height: "97vh", overflow: "hidden", position: "relative" }}>
      {/* Inline CSS for options highlight (so you don't need to edit game.css) */}


      <div className="time" style={{ color: textcolor, position: "absolute", top: 10, left: 20 }}>
        Time: {formatTime(time)}
      </div>

      <div style={{ position: "absolute", top: 10, right: 20, textAlign: "right" }}>
        <div className="scoregame" style={{ color: textcolor }}>Score: {score}</div>
      </div>

      <div style={{ position: "absolute", top: 50, right: 20, display: "block" }}>
        {Array.from({ length: lives }).map((_, i) => (
          <img key={i} src={runningImgs[0] || ''} alt="life" style={{ width: 36, height: 36 }} />
        ))}
      </div>

      {clouds.current.map((cloud, i) => (
        <img
          key={i}
          src={cloudImg}
          alt="cloud"
          style={{
            position: "absolute",
            left: cloud.x,
            top: cloud.y, // Changed from bottom to top positioning
            width: 140 * cloud.scale,
            height: 100 * cloud.scale,
            opacity: 0.6 + (cloud.scale * 0.2), // Slightly more transparent for better visibility
            transition: 'transform 0.2s ease-out',
            transform: `scale(${cloud.scale})`,
            zIndex: 1 // Ensure clouds are behind UI elements
          }}
        />
      ))}
      {[...Array(Math.ceil(gameWidth / 100) + 2)].map((_, i) => <img key={i} src={groundImg} alt="ground" style={{ position: "absolute", bottom: 0, left: i * 250 + groundOffset.current, width: "100%", height: "250px" }} />)}
      <img src={dinoSprite} alt="dino" style={{ position: "absolute", left: dinoX.current, bottom: dinoY.current, width: dinoWidth, height: dinoHeight }} />
      {[...cactusList.current].map((c, i) => <img key={i} src={c.src} alt="cactus" style={{ position: "absolute", left: c.x, bottom: groundHeight, width: c.width, height: c.height }} />)}
      {[...coins.current].map((coin, i) => <img key={i} src={coinImg} alt="coin" style={{ position: "absolute", left: coin.x, bottom: coin.y, width: 30, height: 30 }} />)}

      {quizMode && quiz && (
        <div className="questionmodel">
          <h3 className="questionset">{quiz.question_name}</h3>
          {quizOptions.map((opt, index) => {
            let className = "options";
            const isDisabled = selectedOptionState !== null;
            
            if (selectedOptionState) {
              if (opt === correctOptionState) className += " correct";
              else if (opt === selectedOptionState) className += " wrong";
            }
            
            return (
              <div
                key={index}
                className={`${className}${isDisabled ? " disabled" : ""}`}
                onClick={() => !isDisabled && handleQuizAnswer(opt)}
                style={{ 
                  cursor: isDisabled ? "not-allowed" : "pointer",
                  opacity: isDisabled ? 0.7 : 1,
                  pointerEvents: isDisabled ? "none" : "auto"
                }}
              >
                {opt}
              </div>
            );
          })}
        </div>
      )}

      {!gameStarted && !gameOver && !alreadyPlayedBlocked && (
        <button className="startbtn"
          onClick={() => setGameStarted(true)}
          disabled={fetchError || alreadyPlayedChecking}
          style={{ color: textcolor,backgroundColor: buttonColor, opacity: (fetchError || alreadyPlayedChecking) ? 0.6 : 1, cursor: (fetchError || alreadyPlayedChecking) ? "not-allowed" : "pointer" }}
        >
          {alreadyPlayedChecking
            ? "Checking..."
            : fetchError
              ? "Cannot Start (Error)"
              : "Start Game"}
        </button>
      )}

      {gameOver && (
        <div style={{ padding: "40px 90px", background: "white", borderRadius: "10px", position: "absolute", top: "30%", left: "50%", transform: "translate(-50%,-50%)", textAlign: "center" }}>
          <h1 style={{ marginTop: "10px", fontSize: 48, color: "red" }}>Game Over</h1>
          <div style={{ marginTop: "20px", display: "flex", gap: "10px", justifyContent: "center" }}>

            <button onClick={handleOk} style={{
              background: "#612c14",
              color: "white",
              border: "none",
              borderRadius: "5px", cursor: "pointer", padding: "10px 20px", fontSize: 18
            }}>Ok</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Game;